import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from './FormSection.vue';
import PageLoader from '@/components/PageLoader.vue';

import HmoAccreditations from '@/classes/HmoAccreditations'
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route  = useRoute();
const loader = ref(false)
const form   = ref({})
const hmoId  = ref(route.params.id);

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        count: 0,
        href: '/contents/hmo-accreditation/show/' + hmoId.value,
        allowed: true
    },
];

onMounted(() => {
    loader.value = true;

    HmoAccreditations.showHmo(hmoId.value).then((response) => {
        loader.value = false;

        Object.assign(form.value, response.data[0])
    })
    .catch( () => loader.value = false)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View HMO Accreditation",
    "show-back": "",
    backUrl: "/contents/hmo-accreditation"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, { form: form.value }, null, 8, ["form"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})